<template>
    <b-row class="pre-ordenafrase-activity">
        <b-col lg="12">
            <p>
                <strong>INSTRUCCIONES:</strong>
            </p>
            <p>{{data.instrucciones}}</p>
        </b-col>
        <b-col lg="12" v-for="(frase,index) in data.frases" :key="frase.id">
            <p>
                <strong :id="`txtFrase${index}`">No. {{index + 1}} - {{ frase.frase }}</strong>
            </p>
            <b-form-input
            id="input-answer"
            v-model="frase.fraseShuf"
            type="text"
            :placeholder="`Ingresa una respuesta`">
            </b-form-input>
            <br>
        </b-col>
        <b-col cols="12">
             <b-button
                style="float: right; margin: 10px"
                class="btn btn-success"
                @click="verificarResultados"
            >Verificar Resultados</b-button>
        </b-col>
    </b-row>
</template>
<script>
function shuffle(array) {
    var currentIndex = array.length,
        temporaryValue,
        randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}
export default {
    name: 'pre-ordenafrase',
    props: {
        data: {
            type: Object,
            default: () => {
                return {
                    index: null,
                    tag: 'OrdenaFrase',
                    frases: [],
                    instrucciones: '',
                    frase: ''
                }
            }
        }
    },
    data() {
        return {
            frasesArry: new Array,
            fraseShuf: '',    
        }
    },
    created() {
        this.frasesArry = [];
        this.data.frases.forEach(el => {
            this.frasesArry.push(el.frase);
        });

    },
    methods: {
        verificarResultados() {
            let aciertos = 0;

            this.data.frases.forEach((el, index) => {
                let elemento = document.getElementById(`txtFrase${index}`);
                if (el.fraseShuf == el.frase) {
                    el.acierto = true;
                    elemento.className = 'okAcierto';
                    aciertos++;
                } else {
                    el.acierto = false;
                    elemento.className = 'badAcierto';
                }
            }); 

            let promedio = (100 * aciertos) / this.data.frases.length;

            if (promedio >= 70) {
                this.$swal({
                type: "success",
                title: "¡EN HORA BUENA!",
                text: `Tu promedio de aciertos es del ${Math.round(promedio)}%?`,
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar"
                }).then(result => {
                if (result.value) {
                }
                });
            } else {
                this.$swal({
                type: "warning",
                title: "¡PROMEDIO BAJO!",
                text: `Tu promedio de aciertos es del ${Math.round(promedio)}%?`,
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar"
                }).then(result => {
                if (result.value) {
                }
                });
            }
        },
        triggerOpcionMatch(fraseShuf, value) {
            fraseShuf["match"] = value;
        }
    },
};
</script>
<style lang="scss" scoped>
.pre-ordenafrase-activity{
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #ceebf0;
    border-radius: .5rem;
    border: solid #63c2de .1rem;
    padding-top: 10px;
    padding-bottom: 10px;
}
.okAcierto {
    color: green;
}
.badAcierto {
    color: red;
}
</style>